import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const collectionsPlugin = createPlugin({
  id: 'collections',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindCollectionsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(collectionsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...collectionsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceCollectionsPage = collectionsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceCollectionsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-collections", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
